/**
 * Returns formatted course name.
 *
 * @param {String} courseName Course name
 *
 * @return {String}
 */

export default courseName =>
    courseName && courseName.replace(/<(o|O)>/g, '(').replace(/<(c|C)>/g, ')');



// WEBPACK FOOTER //
// /src/js/common/utils/formatCourseName.js